import React, { useState, useRef, useEffect } from 'react';

const ScrollView = ({ 
  children, 
  style, 
  contentContainerStyle,
  horizontal = false,
  showsHorizontalScrollIndicator = true,
  showsVerticalScrollIndicator = true,
  onScroll,
  scrollEventThrottle = 0,
  ...props 
}) => {
  const scrollRef = useRef();
  const [scrolling, setScrolling] = useState(false);
  
  const convertStyle = (rnStyle) => {
    if (!rnStyle) return {};   
    const cssStyle = { ...rnStyle };
    
    // Handle flex shorthand if present
    if (typeof cssStyle.flex === 'number') {
      cssStyle.flexGrow = cssStyle.flex;
      cssStyle.flexShrink = 1;
      cssStyle.flexBasis = '0%';
      delete cssStyle.flex;
    }
    
    return cssStyle;
  };
  
  const scrollViewStyle = {
    display: 'flex',
    flexDirection: horizontal ? 'row' : 'column',
    overflow: 'auto',
    ...convertStyle(style),
    ...(horizontal && { overflowX: 'auto', overflowY: 'hidden' }),
    ...(!showsHorizontalScrollIndicator && { 
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      WebkitScrollbar: { display: 'none' }
    }),
    ...(!showsVerticalScrollIndicator && { 
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      WebkitScrollbar: { display: 'none' }
    })
  };
  
  const contentStyle = {
    display: horizontal ? 'flex' : 'block',
    flexDirection: horizontal ? 'row' : 'column',
    ...convertStyle(contentContainerStyle)
  };
  
  const handleScroll = (e) => {
    if (onScroll) {
      const { scrollTop, scrollLeft, scrollHeight, scrollWidth, clientHeight, clientWidth } = e.target;
      onScroll({
        nativeEvent: {
          contentOffset: { x: scrollLeft, y: scrollTop },
          contentSize: { width: scrollWidth, height: scrollHeight },
          layoutMeasurement: { width: clientWidth, height: clientHeight }
        }
      });
    }
  };
  
  return (
    <div
      ref={scrollRef}
      style={scrollViewStyle}
      onScroll={handleScroll}
      {...props}
    >
      <div style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default ScrollView;